module.exports = __webpack_public_path__ + "static/img/software12.6ae67105.png";